import React from 'react';

import {
  Form,
  fields,
  formUtil
} from 'iron-forge-react-modules';
import {
  Button,
  Stack,
  Typography
} from '@mui/material';

import { useForm } from 'react-hook-form';
import { BaseWidget } from 'modules/layer01';
import * as types from './types';
import * as dataService from './dataService';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const [
    saveAutomatedEmailReportRecipient,
    saveAutomatedEmailReportRecipientTuple
  ] = dataService.useSaveAutomatedEmailReportRecipient(props.storeId);

  const form = useForm<types.IFormState>({
    defaultValues: {
      email: ''
    }
  });

  formUtil.useSetFormFields(queryTuple, form.setValue, ['email']);



  const processSubmit = React.useCallback(
    (formState: types.IFormState) => {
      saveAutomatedEmailReportRecipient(formState);
    },
    [saveAutomatedEmailReportRecipient]
  );



  const loading = queryTuple.loading || saveAutomatedEmailReportRecipientTuple.loading;

  return (
    <Form.FC
      disableDefaultOverflow
      onSubmit={form.handleSubmit(processSubmit)}>
      <BaseWidget.FC
        title="Automated Reports"
        elAction={(
          <Button
            disabled={loading}
            type="submit">
            Save
          </Button>
        )}>
        <Stack spacing={3}>
          <Typography>
            The recipient set here will be emailed the following reports at the beginning of every business day:
          </Typography>

          <ul>
            <li>An ASN for the previous day</li>
            <li>Cost Report</li>
            <li>Inventory Report</li>
          </ul>

          <ControlledTextField
            label="Recipient Email"
            isDisabled={loading}
            formControl={form.control}
            fieldKey="email" />
        </Stack>
      </BaseWidget.FC>
    </Form.FC>
  );
};
